export const HISTORY_KEY = 'history'
export function getHistory(){
    const h = localStorage.getItem(HISTORY_KEY)
    if(h){
        try{
            return JSON.parse(h)
        }catch (e){
            console.error(e)
            localStorage.removeItem(HISTORY_KEY)
        }
    }
    return []
}

export function dropHistory(){
    localStorage.removeItem(HISTORY_KEY)
}


export function saveHistory(value){
    if(!value) return;
    const history = getHistory()
    // 如果记录中已经存在，那么前移
    if(history.includes(value)){
        history.splice(history.indexOf(value),1);
    }
    // 至多保存50条记录
    if(history.length + 1 > 50){
        history.pop()// 移除最后一条记录
    }
    // 插入记录
    history.unshift(value)
    const str = JSON.stringify(history)
    localStorage.setItem(HISTORY_KEY,str)
    return getHistory();
}
